import EmptyNewsfeedPages from '@web/assets/svg/Misc/empty-newsfeed-pages.svg';
import { NewsfeedEmptyState } from '@web/newsfeed/EmptyStates/NewsfeedEmptyState/NewsfeedEmptyState';

import { getNoPagesText } from './myNewsfeedNoPages.utils';

type Props = {
  canCreatePages: boolean;
};

export const MyNewsfeedNoPages = ({ canCreatePages }: Props) => {
  const { textFirstLine, textSecondLine } = getNoPagesText(canCreatePages);

  return (
    <NewsfeedEmptyState
      firstLine={textFirstLine}
      secondLine={textSecondLine}
      icon={<EmptyNewsfeedPages />}
    />
  );
};
